// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-form-control::after {
  content: unset !important;
}

.filterBtn {
  margin: 0px 5px;
}

.mat-form-field {
  width: 100%;
}

::ng-deep .mat-table th.mat-header-cell {
  white-space: nowrap;
  padding: 0px 8px !important;
}

::ng-deep .mat-table td.mat-cell {
  padding: 0px 8px !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcmVwbHVzLXJlcXVlc3RzLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSx5QkFBeUI7QUFDM0I7O0FBRUE7RUFDRSxlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsV0FBVztBQUNiOztBQUVBO0VBQ0UsbUJBQW1CO0VBQ25CLDJCQUEyQjtBQUM3Qjs7QUFFQTtFQUNFLDJCQUEyQjtBQUM3QiIsImZpbGUiOiJjYXJlcGx1cy1yZXF1ZXN0cy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRhdGUtZm9ybS1jb250cm9sOjphZnRlciB7XG4gIGNvbnRlbnQ6IHVuc2V0ICFpbXBvcnRhbnQ7XG59XG5cbi5maWx0ZXJCdG4ge1xuICBtYXJnaW46IDBweCA1cHg7XG59XG5cbi5tYXQtZm9ybS1maWVsZCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG46Om5nLWRlZXAgLm1hdC10YWJsZSB0aC5tYXQtaGVhZGVyLWNlbGwge1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICBwYWRkaW5nOiAwcHggOHB4ICFpbXBvcnRhbnQ7XG59XG5cbjo6bmctZGVlcCAubWF0LXRhYmxlIHRkLm1hdC1jZWxsIHtcbiAgcGFkZGluZzogMHB4IDhweCAhaW1wb3J0YW50O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-requests/careplus-requests.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,w0BAAw0B","sourcesContent":[".date-form-control::after {\n  content: unset !important;\n}\n\n.filterBtn {\n  margin: 0px 5px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\n::ng-deep .mat-table th.mat-header-cell {\n  white-space: nowrap;\n  padding: 0px 8px !important;\n}\n\n::ng-deep .mat-table td.mat-cell {\n  padding: 0px 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
